import * as React from 'react';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { DeleteButton } from './DeleteButton';

type IType = 'text' | 'select';

interface IInput {
  type: IType;
  placeholder: string;
  value: string;
  open?: boolean;
  list?: any;
  listName?: string;
  onClick?: () => void;
  onChange?: (e: any) => void;
  onSelect?: (item: any) => void;
  onDelete?: () => void;
}

export const Input: React.FC<IInput> = ({
  type,
  listName,
  placeholder,
  value,
  open,
  list,
  onChange,
  onClick,
  onSelect,
  onDelete
}) => {
  const [focus, setFocus] = useState(false);
  const [init, setInit] = useState(true);
  const [searchableList, setSearchAbleList] = useState([]);

  const search = (val: string) => {
    if (list && list.length && val) {
      let result = list.filter((item: any) =>
        item.name.match(new RegExp(value, 'gi'))
      );
      setSearchAbleList(result);
    } else {
      setSearchAbleList(list);
    }
  };

  useEffect(() => {
    if (type === 'select') {
      search(value);
    }
  }, [value]);

  useEffect(() => {
    if (list && list.length && init) {
      setSearchAbleList(list);
      setInit(false);
    }
  }, [list]);

  useEffect(() => {
    if (open) {
      setSearchAbleList(list);
    }
  }, [open]);

  return (
    <StyledInputWrapper
      focus={focus}
      onClick={type === 'select' ? onClick : null}
    >
      {type === 'text' && value ? (
        <DeleteButton onClick={onDelete}>Slett</DeleteButton>
      ) : null}
      <StyledInput
        placeholder={placeholder}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        value={value}
        onChange={onChange ? onChange : () => null}
        hasValue={value ? value : ''}
      />
      {type === 'select' ? <StyledSelectArrow className="arrow" /> : null}
      {type === 'select' && open ? (
        <StyledList>
          {searchableList && searchableList.length
            ? searchableList.map((item: any, index: number) => (
                <StyledListItem
                  key={`${listName}_${index}`}
                  onClick={
                    typeof onSelect === 'function'
                      ? () => {
                          onSelect(item);
                        }
                      : null
                  }
                >
                  {item.name}
                </StyledListItem>
              ))
            : null}
        </StyledList>
      ) : null}
    </StyledInputWrapper>
  );
};

const StyledInputWrapper: any = styled.div`
  transition: background 0.15s ease-in-out;
  position: relative;
  width: 100%;
  border-bottom: 1px solid #2c2d2d;
  background: ${(props: any) => (props.focus ? '#323232' : 'transparent')};

  &:hover {
    cursor: pointer;
    .arrow {
      border-color: white transparent transparent;
    }
  }
`;

const StyledSelectArrow = styled.span`
  position: absolute;
  top: 3px;
  right: 20px;
  bottom: 0;
  margin: auto;
  border-color: #6f7373 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
  pointer-events: none;
`;

const StyledList = styled.ul`
  display: block;
  position: absolute;
  top: 60px;
  padding: 0;
  width: 100%;
  max-height: 200px;
  margin: 0;
  z-index: 100;
  overflow-y: scroll;
  overflow-x: hidden;

  @media screen and (max-width: 800px) {
    top: 0;
    position: relative;
  }
`;
const StyledListItem: any = styled.li`
  line-height: 40px;
  padding: 0 20px;
  background: #444;
  color: white;
  border-bottom: solid 1px rgb(60, 60, 60);

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    cursor: pointer;
    background: #f0ece5;
    color: black;
  }
`;

const StyledInput: any = styled.input`
  background: transparent;
  border: none;
  width: 100%;
  padding: 20px;
  border-radius: 0;
  -webkit-appearance: none;
  font-size: 16px;
  font-weight: 400;
  color: ${(props: any) => (props.hasValue ? 'white' : '#6f7373')};
  outline: none;

  &::-webkit-input-placeholder {
    color: #6f7373;
  }
`;
